export var AdpStatusCode;
(function (AdpStatusCode) {
    AdpStatusCode[AdpStatusCode["ACTIVE"] = 100] = "ACTIVE";
    AdpStatusCode[AdpStatusCode["SUCCESS"] = 200] = "SUCCESS";
    AdpStatusCode[AdpStatusCode["PARTIAL_SUCCESS"] = 206] = "PARTIAL_SUCCESS";
    AdpStatusCode[AdpStatusCode["LOADED"] = 301] = "LOADED";
    AdpStatusCode[AdpStatusCode["END"] = 302] = "END";
    AdpStatusCode[AdpStatusCode["FAIL"] = 500] = "FAIL";
    AdpStatusCode[AdpStatusCode["FAIL_NO_ALLOCATION_CHANGES"] = 506] = "FAIL_NO_ALLOCATION_CHANGES";
    AdpStatusCode[AdpStatusCode["OTP_SUCCESS"] = 700] = "OTP_SUCCESS";
    AdpStatusCode[AdpStatusCode["EXPIRE"] = 904] = "EXPIRE";
    AdpStatusCode[AdpStatusCode["CANCEL"] = 905] = "CANCEL";
})(AdpStatusCode || (AdpStatusCode = {}));
